import { Users, Target, Mail, BarChart3, Rocket, Compass } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface ServiceCard {
  icon: LucideIcon;
  title: string;
  description: string;
}

const services: ServiceCard[] = [
  {
    icon: Users,
    title: "Fractional Growth Leadership",
    description:
      "Team leadership, roadmap development, vendor management, hiring, budgeting, and org design. I embed with your team as your VP of Growth.",
  },
  {
    icon: Target,
    title: "Paid User Acquisition",
    description:
      "Meta, Google, YouTube, TikTok, programmatic — performance frameworks, creative strategy, A/B testing, spend allocation.",
  },
  {
    icon: Mail,
    title: "Lifecycle & CRM",
    description:
      "Email/SMS flows, activation journeys, onboarding optimization, segmentation, winback automations.",
  },
  {
    icon: BarChart3,
    title: "Analytics & Growth Infrastructure",
    description:
      "Amplitude, GA4, Heap, Mixpanel, attribution, LTV modeling, retention curves, funnel mapping, KPI architecture.",
  },
  {
    icon: Rocket,
    title: "Product-Led Growth",
    description:
      "Experiments, onboarding optimization, retention loops, engagement flows, paywall testing, monetization strategy.",
  },
  {
    icon: Compass,
    title: "Brand & GTM Strategy",
    description:
      "Positioning, messaging, campaign development, product launches, creative direction, cross-channel execution.",
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="section-padding bg-secondary">
      <div className="content-max">
        <h2 className="font-headline text-3xl sm:text-4xl md:text-5xl text-foreground tracking-tight mb-4">
          High-Impact Growth Services
        </h2>
        <p className="font-body text-base md:text-lg text-muted-foreground leading-relaxed mb-12 md:mb-16 max-w-2xl">
          Every engagement is powered by AI-augmented workflows — from creative testing to analytics to automation. It's not a separate offering. It's how I work.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-card border border-border rounded-xl p-7 transition-all duration-300 hover:border-primary/40 hover:shadow-[0_0_24px_-6px_hsl(var(--primary)/0.15)] hover:-translate-y-0.5"
            >
              <service.icon
                size={24}
                strokeWidth={1.5}
                className="text-primary mb-5"
              />
              <h3 className="font-body text-base font-semibold text-foreground mb-3">
                {service.title}
              </h3>
              <p className="font-body text-sm text-muted-foreground leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
